import script from "./ParsedMessage.vue?vue&type=script&lang=ts"
export * from "./ParsedMessage.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__